import { Center, Image } from '@chakra-ui/react';
import LoginBg from '@assets/login_bg.png'

const AuthImagePlaceholder = () => (
  <Center w="full" h="full" bg="colorPalette.solid" color="colorPalette.contrast/60" overflow="hidden">
    <Image src={LoginBg} alt="Login Background" objectFit="cover" height="100%" width="100%" />
  </Center>
);

export default AuthImagePlaceholder;
